if(!customElements.get('newsletter-form')) {
  class NewsletterForm extends HTMLElement {
    static formAssociated = true;
    static observedAttributes = ["email", "phone", "message"];
  
    constructor() {
      super();
  
      this.elForm = this.querySelector('form');
      this.elInputs = this.elForm.querySelectorAll('input');
      this.elMessage = this.querySelector('[data-message]');

      this.email = this.getAttribute('email');
      this.phone = this.getAttribute('phone');
      this.listId = this.getAttribute('list-id');
      this.source = this.getAttribute('source');
      this.url = this.elForm.getAttribute('action');

      this.elForm.addEventListener('submit', this.validate.bind(this));
      this.elInputs.forEach(el => {
        el.addEventListener('input', this.setContact.bind(this));
        el.addEventListener('focus', this.reset.bind(this));
        el.addEventListener('focusout', () => {
          const { name } = el;
          !this[name] && this.classList.remove('focussed');
        })
      })
    }

    setContact(ev) {
      const { name, value } = ev.currentTarget;
      this.setAttribute(name, value);
    }
  
    reset() {
      this.elInputs.forEach(el => el.setAttribute('aria-invalid', false));
      this.classList.remove('error', 'success');
      this.classList.add('focussed');
      this.elMessage.textContent = '';
      this.elMessage.className = 'message block mt-3 text-left text-sm';
    }
  
    validate(ev) {
      ev.preventDefault();
      const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
      const hasPhone = Boolean(this.phone);
      const hasCountryCode = this.phone ? this.phone.startsWith('+') : false;
      const hasLettersInPhone = this.phone ? /[a-zA-Z]/.test(this.phone) : false;

      const phoneValidator = window.libphonenumber || null;
      const isPossibleNumber = phoneValidator && this.phone ? phoneValidator.isPossibleNumber(this.phone) : false;
      const isValidNumber = phoneValidator && this.phone ? phoneValidator.isValidNumber(this.phone) : false;

      if (!emailValid) {
        this.elInputs.forEach(el => {
          if (el.name === 'email') el.setAttribute('aria-invalid', true);
        });
        this.setAttribute('message', 'Invalid Email');
        this.classList.add('error');
        return;
      }

      const requiresPhone = this.hasAttribute('phone');
      if (requiresPhone) {
        if (!hasPhone) {
          this.elInputs.forEach(el => {
            if (el.name === 'phone') el.setAttribute('aria-invalid', true);
          });
          this.setAttribute('message', 'Please enter your phone number');
          this.classList.add('error');
          return;
        } else if (hasLettersInPhone) {
          this.elInputs.forEach(el => {
            if (el.name === 'phone') el.setAttribute('aria-invalid', true);
          });
          this.setAttribute('message', 'Phone number should contain only numbers');
          this.classList.add('error');
          return;
        } else if (!hasCountryCode) {
          this.elInputs.forEach(el => {
            if (el.name === 'phone') el.setAttribute('aria-invalid', true);
          });
          this.setAttribute('message', 'Please include + and your country code');
          this.classList.add('error');
          return;
        } else if (phoneValidator && !isPossibleNumber) {
          this.elInputs.forEach(el => {
            if (el.name === 'phone') el.setAttribute('aria-invalid', true);
          });
          this.setAttribute('message', 'Please enter a valid phone number format');
          this.classList.add('error');
          return;
        } else if (phoneValidator && !isValidNumber) {
          this.elInputs.forEach(el => {
            if (el.name === 'phone') el.setAttribute('aria-invalid', true);
          });
          this.setAttribute('message', 'Please enter a valid phone number for your country');
          this.classList.add('error');
          return;
        }
      }

      const btn = this.querySelector('.newsletter-form--button button');
      if (btn) {
        btn.style.minWidth = btn.offsetWidth + 'px';
        btn.style.justifyContent = 'center';
        this._btnHTML = btn.innerHTML;
        btn.innerHTML = '<svg class="animate-spin" width="18" height="18" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.5" opacity="0.3"/><path d="M18 10a8 8 0 01-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
      }

      this.classList.add('submitting');
      this.subscribe()
        .then(response => {
          this.classList.remove('submitting');
          if (btn && this._btnHTML) {
            btn.innerHTML = this._btnHTML;
            btn.style.minWidth = '';
            btn.style.justifyContent = '';
          }

          if(response.ok) {
            this.classList.add('success');
            this.elInputs.forEach(el => { el.value = ''; });
            this.email = '';
            this.phone = '';
            this.elMessage.textContent = 'Thanks for Subscribing!';
            this.elMessage.className = 'flex items-center justify-center h-[54px] rounded-full border border-mint/20 bg-mint/10 mt-3 text-base lg:text-sm text-mint';
          } else {
            this.classList.add('error');
            this.setAttribute('message', 'Oops! Please try again later');
          }
        })
        .catch(err => {
          console.log(err);
          this.classList.remove('submitting');
          if (btn && this._btnHTML) {
            btn.innerHTML = this._btnHTML;
            btn.style.minWidth = '';
            btn.style.justifyContent = '';
          }
          this.classList.add('error');
        });
    }

    async subscribe() {
      const options = {
        method: 'POST',
        headers: { revision: '2024-05-15', 'content-type': 'application/json' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: this.source,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: this.email,
                    phone_number: this.phone
                  }
                }
              }
            },
            relationships: { list: { data: {type: 'list', id: this.listId }}}
          }
        })
      };
  
      return fetch(this.url, options)
        .then(response => response)
        .catch(err => err);
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
      switch (name) {
        case 'email': 
          this.email = newValue;
          break;
        case 'phone':
          this.phone = newValue;
          break;
        case 'message':
          this.elMessage.innerHTML = newValue;
          break;
      }
    }
  }
  
  customElements.define('newsletter-form', NewsletterForm);
}